/*
 * @Description: 
 * @Author: Mankeung
 * @Date: 2021-07-10 15:34:27
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-10 15:35:07
 */
export default [

  {
    path: "userList",
    name: "USER_LIST",
    meta: {
      title: "用户列表",
      icon: "",
      isNav: true,
    },
    component: () =>
      import("@/views/user/userList.vue"),
  },
  {
    path: "userManagement",
    name: "USER_MANAGEMENT",
    meta: {
      title: "用户列表管理",
      icon: "",
      isNav: true,
    },
    component: () =>
      import("@/views/user/userManagement.vue"),
  },
  {
    path: "vipLevel",
    name: "VIP_LEVEL",
    meta: {
      title: "会员等级",
      icon: "",
      isNav: true,
    },
    component: () =>
      import("@/views/user/vipLevel.vue"),
  },
  {
    path: "vipRight",
    name: "VIPRIGHT",
    meta: {
      title: "会员权益",
      icon: "",
      isNav: true,
    },
    component: () =>
      import("@/views/user/vipRight.vue"),
  },
  {
    path:"userDetailPage",
    name:"USER_DETAIL_PAGE",
    meta:{
      title:"用户详情",
      icon:"",
      isNav:false
    },
    component:()=>import("@/views/user/userDetailPage.vue")
  },
  {
    path: "articleManagementList",
    name: "ARTICLE_MANAGEMENT_LIST",
    meta: {
      title: "文章管理列表",
      icon: "",
      isNav: true,
    },
    component: () =>
      import("@/views/user/articleManagement/list.vue"),
  },
  {
    path: "articleManagementCategory",
    name: "ARTICLE_MANAGEMENT_CATEGORY",
    meta: {
      title: "文章分类管理",
      icon: "",
      isNav: true,
    },
    component: () =>
      import("@/views/user/articleManagement/category.vue"),
  },
  {
    path: "courseManagementList",
    name: "COURSE_MANAGEMENT_LIST",
    meta: {
      title: "课程管理列表",
      icon: "",
      isNav: true,
    },
    component: () =>
      import("@/views/user/courseManagement/list.vue"),
  },
  {
    path: "courseManagementCategory",
    name: "COURSE_MANAGEMENT_CATEGORY",
    meta: {
      title: "课程分类管理",
      icon: "",
      isNav: true,
    },
    component: () =>
      import("@/views/user/courseManagement/category.vue"),
  },
  {
    path: "dailyQuestionManagementList",
    name: "DAILY_QUESTION_MANAGEMENT_LIST",
    meta: {
      title: "每日题目管理",
      icon: "",
      isNav: true,
    },
    component: () =>
      import("@/views/user/dailyQuestionManagement/list.vue"),
  },
  // {
  //   path: "dailyQuestionManagement",
  //   name: "DAILY_QUESTION_MANAGEMENT",
  //   meta: {
  //     title: "每日一题",
  //     icon: "",
  //     isNav: true,
  //   },
  //   component: () =>
  //     import("@/views/user/dailyQuestionManagement/questionList.vue"),
  // },
  {
    path: "dailyQuestionManagementCategory",
    name: "DAILY_QUESTION_MANAGEMENT_CATEGORY",
    meta: {
      title: "题目分类管理",
      icon: "",
      isNav: true,
    },
    component: () =>
      import("@/views/user/dailyQuestionManagement/category.vue"),
  },
  {
    path: "dailyQuestionManagementAnswerList",
    name: "DAILY_QUESTION_MANAGEMENT_ANSWER_LIST",
    meta: {
      title: "每日题目答案管理",
      icon: "",
      isNav: true,
    },
    component: () =>
      import("@/views/user/dailyQuestionManagement/answerList.vue"),
  },
  {
    path: "treeHoleManagementList",
    name: "TREE_HOLE_MANAGEMENT_LIST",
    meta: {
      title: "树洞管理列表",
      icon: "",
      isNav: true,
    },
    component: () =>
      import("@/views/user/treeHoleManagement/list.vue"),
  }
];